function calculaTotalMatriculasNovas(tipoMatricula) {

    let id;
    
    if(tipoMatricula === "Nova") {
        id = "numMatriculasNovas"
    }
    else if(tipoMatricula === "Residual") {
        id = "numMatriculasResiduais"
    }

    let numTurmas = document.getElementsByClassName("numTurmas");
    let numAlunosTurmas = document.getElementsByClassName("numAlunosTurmas");
    let numTotalMatriculas = document.getElementsByClassName(id);

    numTurmas = Array.from(numTurmas);
    numAlunosTurmas = Array.from(numAlunosTurmas);
    numTotalMatriculas = Array.from(numTotalMatriculas);

    numTotalMatriculas.map((valor, index) => {
        let v1 = numTurmas[index].value;
        let v2 = numAlunosTurmas[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        v2 = v2 === "" ? 0 : Number.parseFloat(v2);
        valor.value = v1 * v2;
    });

    calculaNumMatriculasNovas()
    calculaNumMatriculasResiduais()

}

function calculaNumMatriculasResiduais() {
    let numTurmas = document.getElementsByClassName("numMatriculasResiduais");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNumMatriculasResiduais").value = total;
}

function calculaNumMatriculasNovas() {
    let numTurmas = document.getElementsByClassName("numMatriculasNovas");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNumMatriculasNovas").value = total;
}

export default { calculaTotalMatriculasNovas }